import { plural } from "../design/format/numbers.ts";

export const shellCopy = {
  nabla: "Nabla",
  marca: "Nabla, visão geral",
  menu: "Menu",
  conversas: "Conversas",
  pularParaConteudo: "Pular para o conteúdo",
  tema: "Alternar tema claro e escuro",
  teclaAjuda: "?",
  abrirLista: "▾",

  busca: {
    placeholder: "Buscar campanha, conjunto ou anúncio",
    curto: "Buscar",
    tecla: "F",
    grupos: { campanha: "Campanhas", conjunto: "Conjuntos", anuncio: "Anúncios" },
    nada: (q: string) => `Nada com “${q}” nas campanhas da Nabla.`,
  },

  frescor: {
    atrasado: (fonte: string, quando: string) => `${fonte} sem leitura desde ${quando}`,
  },

  gaveta: {
    precisam: (n: number) => `${n} ${plural(n, "precisa", "precisam")}`,
    hoje: (n: number) => `${n} hoje`,
    contasTitulo: "CONTAS",
    abertas: (n: number) => `${n} ${plural(n, "aberta", "abertas")}`,
    outrasEmpresas: "OUTRAS EMPRESAS",
    entrarNoCelular: "Entrar no celular",
    sair: "Sair",
  },

  entrarNoCelular: {
    titulo: "Entrar no celular",
    explica: "Para entrar em outro aparelho, abra este link nele. Vale por 10 minutos e uma vez só.",
  },

  navegacao: {
    ondeVoceEsta: "Onde você está",
    irmaos: (i: number, n: number) => `${i} de ${n}`,
    anterior: "Anterior",
    proximo: "Próximo",
  },

  atalhos: {
    titulo: "Atalhos",
    linhas: [
      { teclas: ["Esc"], acao: "Voltar, ou fechar o que estiver aberto" },
      { teclas: ["-"], acao: "Subir um nível" },
      { teclas: ["←", "→"], acao: "Anterior / próximo do mesmo nível" },
      { teclas: ["A", "R", "E"], acao: "Aprovar / Recusar / Ajustar, numa mudança" },
      { teclas: ["U"], acao: "Desfazer, logo depois de decidir" },
      { teclas: ["F"], acao: "Buscar" },
      { teclas: ["?"], acao: "Atalhos" },
    ],
    pinca: "A pinça aproxima o que está sob os dedos e afasta de volta, no trackpad ou na tela.",
    celular: "No celular, toque e segure qualquer coisa para perguntar sobre ela.",
  },

  perguntar: {
    botao: "Perguntar",
    copiarLink: "Copiar link",
  },

  tela: {
    naoCarregou: "Não deu para carregar esta tela.",
    voltarParaVisaoGeral: "Voltar para a visão geral",
    algoDeuErrado: "Algo deu errado nesta tela.",
    recarregarTela: "Recarregar a tela",
  },

  conexao: {
    offline: (desde: string) => `Sem conexão com a Nabla desde ${desde}. O que você vê pode estar desatualizado.`,
    conectado: "Conectado de novo.",
    versaoNova: "Há uma versão nova da Nabla.",
    recarregar: "Recarregar",
  },

  agencia: {
    inicio: "Início da agência",
    entrar: "Entrar pela agência",
  },
  sessao: {
    terminou: "Sua sessão terminou.",
    terminouExplica: "Abra um link de convite, ou use “Entrar no celular” num aparelho onde você ainda está conectado.",
    saiu: "Você saiu.",
  },

  registrado: "Registrado.",

  erroCom: {
    jaDecidida: (quem: string, verbo: string, hora: string) => `Alguém decidiu antes: ${quem} ${verbo} às ${hora}.`,
    valorMudou: (valor: string) => `O valor no Meta mudou desde a proposta (agora ${valor}). Nada foi escrito.`,
    gatewayRecusou: (motivo: string) => `A Nabla recusou: ${motivo}`,
    metaRecusou: (motivo: string) => `O Meta recusou a mudança: ${motivo}. Nada foi aplicado.`,
    limiteDoMeta: (hora: string) => `O Meta pediu uma pausa nesta conta até ${hora}. Nada foi escrito; tente de novo depois disso.`,
  },
} as const;
